import {
  Box,
  Typography,
  Button,
  InputAdornment,
  IconButton,
  InputLabel,
  TextField,
  CircularProgress,
  Stack,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ReactComponent as Logo } from "../../assets/svg/Logo.svg";
import { ReactComponent as BackIcon } from "../../assets/svg/BackIcon.svg";
import CInput from "../../components/CInput";
import PhoneInput from "react-phone-input-2";
import {
  PhoneNumberFormat,
  PhoneNumberType,
  PhoneNumberUtil,
} from "google-libphonenumber";
import "react-phone-input-2/lib/style.css";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { first, isEmpty } from "lodash";
import { toast } from "react-toastify";
import { Setting } from "../../utils/Setting";
import { getApiData } from "../../utils/APIHelper";
import { useDispatch } from "react-redux";
import authActions from "../../redux/reducers/auth/actions";
import { store } from "../../redux/store/configureStore";
import { useLocation, useNavigate } from "react-router-dom";
import useStyles from "./styles";
import { isMobile } from "react-device-detect";
import { askForPermissionToReceiveNotifications } from "../../push-notification";
import CPhoneInput from "../../components/CPhoneInput";
import Images from "../../config/images";
import { GoogleOAuthProvider } from "@react-oauth/google";
import GoogleLoginButton from "../../components/SocialLogin/GoogleLoginButton";
import { useTheme } from "@emotion/react";
import { ReactComponent as TabletLogo } from "../../assets/svg/TabletLogo.svg";
import { initiateContractorOnboardingWorkflow, updateStepMappingToCompleted } from "../../utils/stepMappingUtils";

const errorObj = {
  emailErr: false,
  passwordErr: false,
  phoneErr: false,
  firstNameErr: false,
  lastNameErr: false,
  emailMsg: "",
  passwordMsg: "",
  phoneMsg: "",
  firstNameMsg: "",
  lastNameMsg: "",
};

function Signup() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const classes = useStyles();
  const theme = useTheme();
  const isTablet = useMediaQuery("(max-width:1024px)");
  const isMobile = useMediaQuery("(max-width:820px)");

  const { setUserData, setToken } = authActions;
  const locationState = location?.state ? location?.state : {};
  const phoneUtil = PhoneNumberUtil.getInstance();
  const passwordRegex =
    /^(((?=.*[a-z])(?=.*[A-Z]))((?=.*[a-z]))(?=.*[!@#$%+:^=<(){}[\]~>_?`|'";,.&*€₹£])((?=.*[A-Z])))(?=.{8,})/;
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const isSocial =
    locationState?.type === "google" ||
    locationState?.type === "fb" ||
    locationState?.type === "apple";

  const [step, setStep] = useState(0);
  const [state, setState] = useState({
    email: "",
    password: "",
    phone: "",
    countryCode: "AE",
    pCode: "971",
    firstName: "",
    lastName: "",
  });
  const [errObj, setErrObj] = useState(errorObj);
  const [showPassword, setShowPassword] = useState(false);
  const [btnLoad, setBtnLoad] = useState(false);
  const [locationData, setLocationData] = useState({});
  const [phonePlaceholder, setPhonePlaceholder] = useState("");
  const [socialBtnLoad, setSocialBtnLoad] = useState(false);

  // this function for to get location detail
  useEffect(() => {
    fetch("https://ipapi.co/json/")
      .then((response) => response.json())
      .then((data) => setLocationData(data))
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    console.log("locationData", locationData);
  }, [locationData]);

  useEffect(() => {
    const emailFromSocial = locationState?.socialData?.email;
    const emailFromData = locationState?.data?.email;

    // Prioritize social login email when coming from Google/FB/Apple login
    const emailToUse =
      isSocial && emailFromSocial
        ? emailFromSocial
        : emailFromSocial || emailFromData || "";

    // Update email when locationState changes (e.g., after Google login)
    if (emailToUse) {
      setState((prevState) => ({
        ...prevState,
        email: emailToUse,
      }));
    }
    askForPermissionToReceiveNotifications();
  }, [locationState, isSocial]);

  useEffect(() => {
    const exampleNumber1 = phoneUtil.getExampleNumberForType(
      "ae",
      PhoneNumberType.MOBILE
    );
    const formattedExampleNumber1 = phoneUtil.format(
      exampleNumber1,
      PhoneNumberFormat.NATIONAL
    );
    setPhonePlaceholder(formattedExampleNumber1);
  }, []);

  // this function checks validation of login field
  function validation() {
    console.log("enter");
    // setStep(1);
    // return;

    const { email, password, phone, countryCode, firstName, lastName } = state;
    const error = { ...errObj };
    let valid = true;

    // validate email
    if (isEmpty(email)) {
      valid = false;
      error.emailErr = true;
      error.emailMsg = "Please enter email";
    } else if (!emailRegex.test(email)) {
      valid = false;
      error.emailErr = true;
      error.emailMsg = "Please enter valid email";
    }

    if (
      locationState?.type === "google" ||
      locationState?.type === "fb" ||
      locationState?.type === "apple"
    ) {
    } else {
      // validate password
      if (isEmpty(password)) {
        valid = false;
        error.passwordErr = true;
        error.passwordMsg = "Please enter password";
      } else if (password.length < 8) {
        valid = false;
        error.passwordErr = true;
        error.passwordMsg = "Password length must be of 8-15";
      } else if (!passwordRegex.test(password)) {
        valid = false;
        error.passwordErr = true;
        error.passwordMsg =
          "Password must include more than 8 characters, at least one number, one letter, one capital letter and one symbol";
      }
    }

    // Validate phone
    if (step === 1) {
      if (isEmpty(phone)) {
        valid = false;
        error.phoneErr = true;
        error.phoneMsg = "Please enter phone number";
      } else if (!isEmpty(phone) && !isEmpty(countryCode)) {
        const phoneNumber1 = phoneUtil.parse(phone, countryCode);
        const isValid = phoneUtil.isValidNumber(phoneNumber1);
        if (!isValid) {
          valid = false;
          error.phoneErr = true;
          error.phoneMsg = `Please enter valid phone number Ex: ${phonePlaceholder}`;
        }
      }

      if (isEmpty(firstName)) {
        valid = false;
        error.firstNameErr = true;
        error.firstNameMsg = "Please enter first name";
      }

      if (isEmpty(lastName)) {
        valid = false;
        error.lastNameErr = true;
        error.lastNameMsg = "Please enter last name";
      }
    }

    setErrObj(error);
    if (valid) {
      console.log("enter1");
      if (step === 0) {
        setStep(1);
      } else {
        registerUser();
      }
    }
  }

  async function registerUser() {
    setBtnLoad(true);
    console.log("enter3");
    const { email, phone, password, pCode, firstName, lastName } = state;
    const address = `${locationData?.city ? locationData?.city + "," : ""} ${
      locationData?.region ? locationData?.region + "," : ""
    } ${locationData?.country_name || ""}`;

    const userAgent = window.navigator.userAgent;
    const isSafari = userAgent.includes("Safari");

    let data = {
      email,
      password,
      first_name: firstName,
      last_name: lastName,
      phone_code: pCode ? pCode : "",
      phone_no: phone,
      device_type: "web",
      device_name: locationData?.ip || "",
      login_address: address,
      notification:
        isSafari && isMobile
          ? 0
          : Notification?.permission === "granted"
          ? 1
          : 0,
    };
    if (isSocial) {
      data.social_connection = locationState?.type;
      data.token = locationState?.socialData?.password;
    }
    console.log("signup data", data);

    try {
      const response = await getApiData(`api/contractor/signup`, "POST", data);
      console.log("response =register user====>>> ", response);

      if (response.success) {
        // toast.success(response?.message || "");
        
        // Initialize contractor onboarding workflow for new users (including Google sign up)
        try {
          const userId = response?.data?.id;
          const userToken = response?.token;
          if (userId && userToken) {
            await initiateContractorOnboardingWorkflow(userId, userToken);
            await updateStepMappingToCompleted(userId, "CREATE_ACCOUNT", userToken);
            console.log("Contractor onboarding workflow initiated for signup user");
          }
        } catch (error) {
          console.log("Error initiating contractor onboarding workflow:", error);
        }
        
        if (
          response?.is_email_verified === false ||
          response?.data?.is_email_verified === false
        ) {
          navigate("/otp-verify", { state: { data, type: "email" } });
          dispatch(setUserData(response?.data));
        } else if (response.is_role_added === false) {
          navigate("/role");
          dispatch(setUserData(response?.data));
        } else {
          dispatch(setToken(response?.token));
          dispatch(setUserData(response?.data));
          navigate("/create-profile");
        }
      } else {
        toast.error(response.message);
      }
      setBtnLoad(false);
    } catch (error) {
      console.log("🚀 ~ file: index.js:63 ~ registeruser ~ error:", error);
      setBtnLoad(false);
      toast.error(error.toString());
    }
  }

  async function googleDataApiCall(googleCode) {
    try {
      setSocialBtnLoad("google");
      const response = await getApiData(Setting.endpoints.googleData, "POST", {
        code: googleCode,
      });

      if (response.success) {
        if (!isEmpty(response?.data)) {
          socialLoginApiCall(response?.data, "google");
        }
      } else {
        toast.error(response.message);
        setSocialBtnLoad("");
      }
    } catch (error) {
      console.log("🚀 ~ google data api call ~ error:", error);
      toast.error(error.toString());
      setSocialBtnLoad("");
    }
  }

  async function socialLoginApiCall(socialData, type) {
    setSocialBtnLoad(type);
    const address = `${locationData?.city ? locationData?.city + "," : ""} ${
      locationData?.region ? locationData?.region + "," : ""
    } ${locationData?.country_name || ""}`;
    try {
      const response = await getApiData(Setting.endpoints.login, "POST", {
        email: socialData?.email ? socialData?.email : "",
        password: socialData?.password ? socialData?.password : "",
        device_type: "web",
        social_connection: type ? type : "",
        device_name: locationData?.ip || "",
        login_address: address,
      });

      if (response.success) {
        dispatch(setToken(response?.token));
        if (response?.is_new_user) {
          setSocialBtnLoad("");
          navigate("/signup", {
            state: { socialData, type, data: response?.data },
          });
        } else if (
          response?.is_email_verified === false ||
          response?.data?.is_email_verified === false
        ) {
          dispatch(setUserData(response?.data));
          navigate("/otp-verify", {
            state: { data: response?.data, type: "email" },
          });
        } else if (
          response?.is_phone_verified === false ||
          response?.data?.is_phone_verified === false
        ) {
          navigate("/phone-verify", {
            state: { data: response?.data, type: "phone" },
          });
        } else if (response?.is_role_added === false) {
          dispatch(setUserData(response?.data));
          navigate("/role");
        } else if (
          response?.data?.contractor_data &&
          response?.data?.contractor_data?.profile_completed === "pending"
        ) {
          dispatch(setUserData(response?.data));
          navigate("/create-profile");
        } else {
          dispatch(setUserData(response?.data));
          setSocialBtnLoad("");
          navigate("/dashboard");
        }
      } else if (response.success === false) {
        dispatch(setToken(response?.token));
        if (
          response?.is_email_verified === false ||
          response?.data?.is_email_verified === false
        ) {
          dispatch(setUserData(response?.data));
          navigate("/otp-verify", {
            state: { data: response?.data, type: "email" },
          });
        } else if (
          response?.is_phone_verified === false ||
          response?.data?.is_phone_verified === false
        ) {
          navigate("/phone-verify", {
            state: { data: response?.data, type: "phone" },
          });
        } else {
          setSocialBtnLoad("");
          toast.error(response.message);
        }
      } else {
        setSocialBtnLoad("");
        toast.error(response.message);
      }
    } catch (error) {
      console.log("🚀 ~ file: index.js:63 ~ loginUser ~ error:", error);
      setSocialBtnLoad("");
      toast.error(error.toString());
    }
  }

  useEffect(() => {
    setStep(0);
  }, []);

  const handleBackClick = () => {
    if (step === 0) {
      store.dispatch(authActions.clearAllData());
      navigate("/login");
    } else if (step === 1) {
      setStep(0);
    }
  };

  return (
    <>
      <Box
        sx={{
          minHeight: "100vh",
          backgroundImage: 'url("/assets/images/bg4.png")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
          textAlign: "center",
          px: 3,
          pt: isMobile ? 4 : isTablet ? 4 : 8,
          overflowX: "none",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: isMobile ? "35px" : isTablet ? "15px" : "20px",
            width: isMobile ? "100%" : isTablet ? "60%" : "50%",
          }}
        >
          <div>{isTablet ? <TabletLogo /> : <Logo />}</div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <BackIcon onClick={handleBackClick} style={{ cursor: "pointer" }} />
            <div
              style={{
                width: "100%",
                fontSize: isMobile ? "1.3rem" : isTablet ? "1.3rem" : "40px",
                fontFamily: "Inter Tight",
                textAlign: "center",
                fontWeight: "600",
                color: "#000000",
                letterSpacing: "-0.4px",
              }}
            >
              {step === 0 ? "Create an account" : "Enter your information"}
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              width: isMobile ? "95%" : "55%",
              textAlign: "left",
            }}
          >
            {step === 0 ? (
              <>
                <CInput
                  outline
                  label="Email"
                  placeholder="Enter email address"
                  value={state.email}
                  disabled={
                    isSocial &&
                    emailRegex.test(locationState?.socialData?.email)
                  }
                  onChange={(e) => {
                    setState({ ...state, email: e.target.value });
                    setErrObj({ ...errObj, emailErr: false, emailMsg: "" });
                  }}
                  white={false}
                  error={errObj.emailErr}
                  helpertext={errObj.emailMsg}
                  className={classes.label}
                />

                {locationState?.type === "google" ||
                locationState?.type === "fb" ||
                locationState?.type === "apple" ? null : (
                  <>
                    <CInput
                      className={classes.label}
                      outline
                      label="Password"
                      placeholder="Enter password"
                      type={showPassword ? "text" : "password"}
                      value={state.password}
                      passValue={state?.password}
                      passwordValidation
                      inputProps={{ maxLength: 15 }}
                      onChange={(e) => {
                        setState({ ...state, password: e.target.value });
                        setErrObj({
                          ...errObj,
                          passwordErr: false,
                          passwordMsg: "",
                        });
                      }}
                      onKeyPress={(ev) => {
                        if (ev.key === "Enter") {
                          ev.preventDefault();
                          validation();
                        }
                      }}
                      white={false}
                      error={errObj.passwordErr}
                      helpertext={errObj.passwordMsg}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {!showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </>
                )}
              </>
            ) : (
              <>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <CInput
                    outline
                    label="First Name"
                    placeholder="Enter first name"
                    value={state.firstName}
                    onChange={(e) => {
                      setState({ ...state, firstName: e.target.value });
                      setErrObj({
                        ...errObj,
                        firstNameErr: false,
                        firstNameMsg: "",
                      });
                    }}
                    white={false}
                    error={errObj.firstNameErr}
                    helpertext={errObj.firstNameMsg}
                    className={classes.label}
                  />

                  <CInput
                    outline
                    label="Last Name"
                    placeholder="Enter last name"
                    value={state.lastName}
                    onChange={(e) => {
                      setState({ ...state, lastName: e.target.value });
                      setErrObj({
                        ...errObj,
                        lastNameErr: false,
                        lastNameMsg: "",
                      });
                    }}
                    white={false}
                    error={errObj.lastNameErr}
                    helpertext={errObj.lastNameMsg}
                    className={classes.label}
                  />
                </div>
                <CPhoneInput
                  label="WhatsApp Number"
                  required
                  placeholder="Enter phone number"
                  value={state.phone}
                  onChange={(e) => {
                    setState({ ...state, phone: e.target.value });
                    setErrObj({ ...errObj, phoneErr: false, phoneMsg: "" });
                  }}
                  state={state}
                  setState={setState}
                  error={errObj.phoneErr}
                  helpertext={errObj.phoneMsg}
                  className={classes.label}
                />
              </>
            )}
            <Stack
              direction="column"
              spacing={2}
              justifyContent="center"
              alignItems={"center"}
            >
              <center>
                <button
                  style={{
                    marginTop: "2vh",
                    width: "fit-content",
                    padding: isMobile ? "1.5vh 10vw" : "1.5vh 5vw",
                    backgroundColor: "#4D6BF6",
                    borderRadius: "12px",
                    fontSize: "16px",
                    fontWeight: "600",
                    boxShadow: "none",
                    border: "1px solid transparent",
                    color: "#fff",
                    cursor: "pointer",
                    fontFamily: "Inter Tight",
                    textAlign: "center",
                  }}
                  onClick={validation}
                  disabled={btnLoad}
                >
                  {btnLoad ? (
                    <CircularProgress size={24} sx={{ color: "#fff" }} />
                  ) : (
                    <>{step === 0 ? "Continue" : "Create your Reno account"}</>
                  )}
                </button>
              </center>

              <img src={Images.divider} alt="divider" />

              <GoogleOAuthProvider clientId={Setting.GOOGLE_CLIENT_ID}>
                <GoogleLoginButton
                  loader={socialBtnLoad === "google"}
                  onGoogleDone={(val) => googleDataApiCall(val?.code)}
                />
              </GoogleOAuthProvider>
            </Stack>
          </div>
        </Box>
      </Box>
    </>
  );
}

export default Signup;
